<!--div class="input" [ngClass]="validationClass" *ngIf=!inputDate-->
<div class="input" [ngClass]="validationClass">
    <span *ngIf="name" class="input-name">{{name}}</span>
    <span *ngIf="required" class="required-red">*</span>
  <div style="position:relative">
    <img *ngIf="withImage" src="../../../../content/images/Magnifier.svg" class="input-image" (click)="imageClicked.emit(value)">
    <!--input type="text" (blur)="onSaveModel()" inputPattern [inputTypePattern]="inputTypePattern" (focus)="onSaveState()"
      class="input-component" [(ngModel)]="value" (keyup)="onChange()" [placeholder]="placeholder" [disabled]="!!disabled"
      [maxLength]="maxTextLength" mask="{{maskPattern}}"-->
    <input [type]="inputType" (blur)="onSaveModel()" inputPattern [inputTypePattern]="inputTypePattern" (focus)="onSaveState()"
      class="input-component" [(ngModel)]="value" (change)="onChange()" [placeholder]="placeholder" [disabled]="!!disabled"
      [maxLength]="maxTextLength" (keydown.enter)="onEnter($event)">
    <img *ngIf="showEye" src='../../../../content/images/eye.svg' (click)="showHideValue()" class="show-hidden-value">
    <div class="hider" *ngIf="hideValue && showEye && value">X</div>
  </div>
</div>
